import React, { useState, useEffect } from "react";
import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
import PageContainer from "../../components/PageContainer/PageContainer";
// Components
import {
  Grid,
  Box,
  Button,
  useMediaQuery,
  CircularProgress,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// Assets
import {
  IconoTarjetaAdicional,
} from "assets";
// Service
import PublicServices from "services/publicService";
import ClientService from "services/clientService";
import AdditionalServices from "services/additionalServices.js";
import { getSessionDocument } from "services/sessionStorageService";
import { useRedirect, URLs } from "../../utils/redirectStep";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && <Box sx={{ p: 0, width: "100%" }}>{children}</Box>}
    </div>
  );
}

function TabInputs({ mobile, errors, handleInputChange, index, values }) {
  const classes = useStyles();
  return (
    <>
      <TextField
        id={`nombre-${index}`}
        name="nombre"
        label="Nombre*"
        variant="filled"
        className={classes.inputCustom}
        value={values.nombre}
        onChange={(e) => handleInputChange(e, index)}
        sx={{
          width: "100%",
          marginBottom: "1rem",
        }}
      />
      <TextField
        id={`apellido-${index}`}
        name="apellido"
        label="Apellido*"
        variant="filled"
        className={classes.inputCustom}
        value={values.apellido}
        onChange={(e) => handleInputChange(e, index)}
        sx={{
          width: "100%",
          marginBottom: "1rem",
        }}
      />
      <TextField
        id={`cedula-${index}`}
        name="cedula"
        label="Cédula de identidad*"
        variant="filled"
        className={classes.inputCustom}
        value={values.cedula}
        onChange={(e) => handleInputChange(e, index)}
        inputProps={{ maxLength: 9 }}
        sx={{
          width: "100%",
          marginBottom: "1rem",
        }}
      />
      <TextField
        id={`celular-${index}`}
        name="celular"
        label="Celular*"
        variant="filled"
        className={classes.inputCustom}
        value={values.celular}
        onChange={(e) => handleInputChange(e, index)}
        inputProps={{ maxLength: 9 }}
        sx={{
          width: "100%",
          marginBottom: "1rem",
        }}
      />
    </>
  );
}

function ServiciosAdicionales() {
  //Inicializaciones base
  const clientService = new ClientService();
  const additionalServices = new AdditionalServices();
  const publicService = new PublicServices();
  const { tipoTarjeta } = useParams();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [apiCrash, setApiCrash] = useState(false);
  const [categoriasServicios, setCategoriasServicios] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [modal, setModal] = React.useState({
    open: false,
    title: "",
    img: null,
    message: "",
    content: null,
  });

  const [additionalCards, setAdditionalCards] = useState({
    adicionales: [
      { nombre: "", apellido: "", cedula: "", celular: "" },
      { nombre: "", apellido: "", cedula: "", celular: "" },
      { nombre: "", apellido: "", cedula: "", celular: "" },
      { nombre: "", apellido: "", cedula: "", celular: "" },
    ],
  });

  const [hiredServices, setHiredService] = useState({
    codigoServicio: [],
  });

  // Inicializaciones particulares
  const [selectedTab, setSelectedTab] = useState(0);
  const [errors, setErrors] = useState({});

  const handleModalCloseClick = () => setModal({ ...modal, open: false });

  useEffect(() => {
    setLoading(true);
    const documento = getSessionDocument();
    const codProducto = location.state.transaction.codigoProducto;
    const getServiciosPorProducto = async () => {
      try {
        const response = await additionalServices.serviciosPorProducto(
          codProducto,
          documento
        );
        setCategoriasServicios(response?.data?.categorias);
        !response.data ? setApiCrash(true) : setApiCrash(false);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getServiciosPorProducto();
  }, []);

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  // useEffect(() => {
  //   console.log(hiredServices);
  // }, [hiredServices]);

  // useEffect(() => {
  //   console.log(additionalCards);
  // }, [additionalCards]);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    let isValid = false;
    if (name === "cedula" || name === "celular") {
      isValid = /^\d{0,9}$/.test(value);
    }
    if (name === "nombre" || name === "apellido") {
      isValid = /^[A-Za-z\s]*$/.test(value);
    }
    if (isValid) {
      setAdditionalCards((prevState) => {
        const newAdicionales = prevState.adicionales.map((adicional, idx) => {
          if (idx === index) {
            return { ...adicional, [name]: value };
          }
          return adicional;
        });
        return { ...prevState, adicionales: newAdicionales };
      });
    }
  };

  const handleValidation = () => {
    let valid = true;
    let newErrors = {};
    setErrors(newErrors);
    return valid;
  };

  const handleAddHiredService = (idService) => {
    setHiredService((prevState) => ({
      ...prevState,
      codigoServicio: [...prevState.codigoServicio, idService],
    }));
  };

  const handleDeleteHandleHiredService = (idService) => {
    setHiredService((prevState) => ({
      ...prevState,
      codigoServicio: prevState.codigoServicio.filter(
        (serviceId) => serviceId !== idService
      ),
    }));
  };

  const isHiredService = (idService) => {
    return hiredServices.codigoServicio.includes(idService);
  };

  const hiredServicesIsAnEmptyList = () => {
    return hiredServices.codigoServicio.length == 0;
  };

  const additionalCardsIsAnEmptyList = () => {
    const validCards = additionalCards.adicionales.filter(
      (card) => card.nombre && card.apellido && card.cedula && card.celular
    );
    const updatedAdditionalCards = {
      ...additionalCards,
      adicionales: validCards,
    };
    return updatedAdditionalCards.adicionales.length == 0;
  };

  const openModalSinServiciosAdicionales = () => {
    setModal({
      open: true,
      showX: true,
      content: (
        <Box className={classes.modalContentDynamic}>
          <h3 className={classes.modalTitle}>
            ¡No se ha seleccionado<br></br> ningún producto o servicio!
          </h3>
        </Box>
      ),
    });
  };

  const handleOmitir = async () => {
    setLoading(true);
    const newTransaction = {
      ...location.state.transaction,
    };
    navigate(buildNavigateUrl(URLs.verificacionCelular), {
      state: { transaction: newTransaction },
    });
  };

  const handleHiredService = async () => {
    setLoading(true);
    if (additionalCardsIsAnEmptyList() && hiredServicesIsAnEmptyList()) {
      openModalSinServiciosAdicionales();
      setLoading(false);
    } else {
      try {
        if (hiredServicesIsAnEmptyList()) {
          postHiredService();
        }
        if (additionalCardsIsAnEmptyList()) {
          postAdditionalCards();
        }
        const newTransaction = {
          ...location.state.transaction,
        };
        navigate(URLs.verificacionCelular, {
          state: { transaction: newTransaction },
        });
      } catch (error) {
        const newTransaction = {
          ...location.state.transaction,
        };
        navigate(URLs.intenteLuego, {
          state: { transaction: newTransaction },
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const postHiredService = async () => {
    try {
      clientService.hiredServices(hiredServices, location.state.transaction);
    } catch (error) {
      navigate(buildNavigateUrl(URLs.intenteLuego));
    }
  };

  const postAdditionalCards = async () => {
    try {
      const validCards = additionalCards.adicionales.filter(
        (card) => card.nombre && card.apellido && card.cedula && card.celular
      );
      const updatedAdditionalCards = {
        ...additionalCards,
        adicionales: validCards,
      };
      await clientService.additionalCards(
        updatedAdditionalCards,
        location.state.transaction
      );
    } catch (error) {
      navigate(buildNavigateUrl(URLs.intenteLuego));
    }
  };

  // const handleValidateCelular = (celular) => {
  //   const celularRegex = /^09\d{7}$/;
  //   return celularRegex.test(celular);
  // };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
     <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.adicionales}
    >
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          padding: "0",
          minHeight: "100vh",
          paddingBottom: "1rem",
        }}
      >
        <p
          style={{
            fontSize: mobile ? "10px" : "14px",
            lineHeight: "1.2",
            width: "90%",
            fontWeight: "600",
            textAlign: "center",
            marginTop: "0.5rem",
            marginBottom: "2rem",
          }}
        >
          OTROS PRODUCTOS Y/O SERVICIOS QUE PODÉS AGREGAR
        </p>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            // marginTop: "1rem",
            width: "90%",
            maxWidth: mobile ? "380px" : "750px",
          }}
        >
          <Grid
            container
            spacing={mobile ? 1 : 4}
            sx={{ maxWidth: apiCrash ? "420px" : "auto" }}
          >
            <Grid
              item
              xs={12}
              md={apiCrash ? 12 : 6}
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
            >
              <Typography
                variant="body1"
                style={{
                  fontSize: mobile ? "12px" : "14px",
                  color: "#606060",
                }}
              >
                Producto
              </Typography>
              <Box sx={{ width: "100%" }}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ marginTop: "1rem" }}
                  >
                    <p style={{ fontWeight: 600, color: "#04808F" }}>
                      TARJETA ADICIONAL
                    </p>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p style={{ fontSize: "12px" }}>¿Qué incluye? </p>
                    <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
                      <li style={{ display: "flex", marginBottom: "0.3rem" }}>
                        <img
                          src={IconoTarjetaAdicional}
                          style={{
                            marginRight: "8px",
                            width: "15px",
                            height: "15px",
                          }}
                        />
                        <p style={{ fontSize: "12px" }}>
                          Podés agregar hasta{" "}
                          <span className="special-font">4</span> tarjetas
                          adicionales gratis.
                        </p>
                      </li>
                      <li style={{ display: "flex", marginBottom: "1rem" }}>
                        <img
                          src={IconoTarjetaAdicional}
                          style={{
                            marginRight: "8px",
                            width: "15px",
                            height: "15px",
                          }}
                        />
                        <p style={{ fontSize: "12px" }}>
                          Todos los que tengan las adicionales disfrutan de los
                          mismos beneficios que vos.
                        </p>
                      </li>
                    </ul>

                    <Tabs
                      value={selectedTab}
                      onChange={handleTabChange}
                      variant="fullWidth"
                      indicatorColor="primary"
                      textColor="primary"
                      sx={{ marginBottom: "1rem", width: "100%" }}
                    >
                      <Tab
                        label="Adicional 1"
                        sx={{
                          fontSize: mobile ? "8px" : "10px",
                          fontWeight: selectedTab === 0 ? "600" : "400",
                          color: "black",
                          minWidth: "25%!important",
                          padding: "12px 9px",
                        }}
                      />
                      <Tab
                        label="Adicional 2"
                        sx={{
                          fontSize: mobile ? "8px" : "10px",
                          fontWeight: selectedTab === 1 ? "600" : "400",
                          color: "black",
                          minWidth: "25%!important",
                          padding: "12px 9px",
                        }}
                      />
                      <Tab
                        label="Adicional 3"
                        sx={{
                          fontSize: mobile ? "8px" : "10px",
                          fontWeight: selectedTab === 2 ? "600" : "400",
                          color: "black",
                          minWidth: "25%!important",
                          padding: "12px 9px",
                        }}
                      />
                      <Tab
                        label="Adicional 4"
                        sx={{
                          fontSize: mobile ? "8px" : "10px",
                          fontWeight: selectedTab === 3 ? "600" : "400",
                          color: "black",
                          minWidth: "25%!important",
                          padding: "12px 9px",
                        }}
                      />
                    </Tabs>
                    <TabPanel value={selectedTab} index={0}>
                      <TabInputs
                        mobile={mobile}
                        errors={errors}
                        handleInputChange={handleInputChange}
                        index={0}
                        values={additionalCards.adicionales[0]}
                      />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                      <TabInputs
                        mobile={mobile}
                        errors={errors}
                        handleInputChange={handleInputChange}
                        index={1}
                        values={additionalCards.adicionales[1]}
                      />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                      <TabInputs
                        mobile={mobile}
                        errors={errors}
                        handleInputChange={handleInputChange}
                        index={2}
                        values={additionalCards.adicionales[2]}
                      />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3}>
                      <TabInputs
                        mobile={mobile}
                        errors={errors}
                        handleInputChange={handleInputChange}
                        index={3}
                        values={additionalCards.adicionales[3]}
                      />
                    </TabPanel>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </Grid>
            {categoriasServicios &&
              categoriasServicios.map((categoria, index) => (
                <Grid
                  item
                  key={index}
                  xs={12}
                  md={6}
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  sx={{ marginTop: mobile ? "1rem" : "0rem" }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontSize: mobile ? "12px" : "14px",
                      color: "#606060",
                    }}
                  >
                    {categoria.nombre}
                  </Typography>
                  {categoria.servicios.map((servicio, index) => (
                    <Box sx={{ width: "100%", marginTop: "1rem" }} key={index}>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <p style={{ fontWeight: 600, color: "#04808F" }}>
                            {servicio.titulo}
                          </p>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              marginBottom: "0.5rem",
                            }}
                          >
                            {servicio.icono && (
                              <img
                                src={servicio.icono}
                                style={{
                                  marginRight: "8px",
                                  width: "auto",
                                  height: "36px",
                                }}
                              />
                            )}
                            {servicio.textoIcono && (
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 700,
                                  maxWidth: "50%",
                                }}
                              >
                                {servicio.textoIcono}
                              </p>
                            )}
                          </Box>
                          <Box sx={{ marginLeft: "1rem" }}>
                            <p style={{ fontSize: "12px" }}>
                              {servicio.textoSecundario}
                            </p>
                            <ul
                              style={{
                                listStyleType: "none",
                                paddingLeft: "0",
                              }}
                            >
                              {servicio.beneficios.map((beneficio, index) => (
                                <li
                                  style={{
                                    display: "flex",
                                    marginBottom: "0.3rem",
                                  }}
                                  key={index}
                                >
                                  {beneficio.icono && (
                                    <img
                                      src={beneficio.icono}
                                      style={{
                                        marginRight: "8px",
                                        width: "15px",
                                        height: "15px",
                                      }}
                                    />
                                  )}
                                  <p style={{ fontSize: "12px" }}>
                                    {beneficio.leyenda}
                                  </p>
                                </li>
                              ))}
                            </ul>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                width: "100%",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 700,
                                  width: "50%",
                                  marginRight: "0.7rem",
                                }}
                              >
                                {categoria.beneficioExtra}
                              </p>
                              <Button
                                className={`${classes.btnFull} ${
                                  !isHiredService(servicio.codigoServicio)
                                    ? classes.btnAzul
                                    : classes.btnGrey
                                }`}
                                variant="text"
                                disabled={isHiredService(
                                  servicio.codigoServicio
                                )}
                                onClick={() =>
                                  handleAddHiredService(servicio.codigoServicio)
                                }
                                sx={{
                                  maxWidth: "40px",
                                  fontWeight: 700,
                                  border: "0.5px solid #04808F",
                                  height: "30px",
                                  marginRight: "0.7rem",
                                  borderRadius: "6px!important",
                                }}
                              >
                                {"SI"}
                              </Button>
                              <Button
                                className={`${classes.btnFull} ${
                                  isHiredService(servicio.codigoServicio)
                                    ? classes.btnAzul
                                    : classes.btnGrey
                                }`}
                                variant="text"
                                disabled={
                                  !isHiredService(servicio.codigoServicio)
                                }
                                onClick={() =>
                                  handleDeleteHandleHiredService(
                                    servicio.codigoServicio
                                  )
                                }
                                sx={{
                                  maxWidth: "40px",
                                  border: "0.5px solid #04808F",
                                  fontWeight: 700,
                                  height: "30px",
                                  borderRadius: "6px!important",
                                }}
                              >
                                {"NO"}
                              </Button>
                            </Box>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  ))}
                </Grid>
              ))}
          </Grid>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              //   width: mobile ? "90%" : "100%",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "0.5rem",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: "380px",
                }}
              >
                <div className={classes.divBtn}>
                  <Button
                    className={`${classes.btnFull} ${classes.btnAzul}`}
                    variant="text"
                    onClick={handleHiredService}
                    sx={{
                      width: "100%",
                      marginTop: "1rem",
                    }}
                  >
                    {"SOLICITAR SERVICIOS"}
                  </Button>
                </div>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: "380px",
                }}
              >
                <div className={classes.divBtn}>
                  <Button
                    className={`${classes.btnFull}`}
                    variant="text"
                    disabled={loading}
                    onClick={handleOmitir}
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFFF",
                      border: "1px solid #04808F",
                      marginTop: "0.5rem",
                      marginBottom: "1rem",
                    }}
                  >
                    {"OMITIR"}
                  </Button>
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      </PageContainer>
    </>
  );
}

export default ServiciosAdicionales;
